module.exports = __webpack_public_path__ + "static/4-1-22b972d5bdf3200d0afad504b92a76bb.png";